// extracted by mini-css-extract-plugin
export var button = "QuickActionDropdown-module--button--VvLUW";
export var container = "QuickActionDropdown-module--container--9AKzx";
export var content = "QuickActionDropdown-module--content--bZR8T";
export var hidden = "QuickActionDropdown-module--hidden--yv+Y2";
export var mobile = "QuickActionDropdown-module--mobile--YwHei";
export var overlay = "QuickActionDropdown-module--overlay--ezLBD";